export function getLineOffsets(text: string): number[] {
  const offsets = [0];
  let pos = 0;
  while ((pos = text.indexOf("\n", pos)) !== -1) {
    offsets.push(++pos);
  }
  return offsets;
}
